import axios from 'axios'

const getApi = async () =>
  await axios.get(`${process.env.REACT_APP_ADA_POOLS_API_URL}/api`)

export default getApi
